import PropTypes from 'prop-types';
import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../../organisms/Layout/Layout';
import BubbleCtaSection from '../../organisms/BubbleCtaSection/BubbleCtaSection';
import { renderPageSections } from '../renderPageSections';

const GtmPage = ({ data, location: { href } }) => {
  // unpublished pages return null data
  if (!data || data.sanityGtmPage === null) {
    return null;
  }

  const gtmPageProps = {
    id: data.sanityGtmPage._id,
    metadata: { ...data.sanityGtmPage._rawRoute, href },
    sections: data.sanityGtmPage._rawSections,
    bubbleCtaSection: data.sanityGtmPage._rawBubbleCtaSection,
  };

  return (
    <Layout
      menuColor="white"
      sanityId={gtmPageProps.id}
      {...gtmPageProps.metadata}
    >
      {renderPageSections(gtmPageProps.sections)}
      {gtmPageProps.bubbleCtaSection && (
        <BubbleCtaSection {...gtmPageProps.bubbleCtaSection} />
      )}
    </Layout>
  );
};

GtmPage.propTypes = {
  data: PropTypes.shape({ sanityGtmPage: {} }),
  location: PropTypes.shape({ href: PropTypes.string }),
};

GtmPage.defaultProps = {
  data: {},
  location: { href: '' },
};

export default GtmPage;

export const query = graphql`
  query($slug: String) {
    sanityGtmPage(
      route: { enabled: { eq: true }, slug: { current: { eq: $slug } } }
    ) {
      route {
        routeName
        metaTitle
        metaDescription
        metaKeywords
      }
      _id
      _rawSections(resolveReferences: { maxDepth: 100 })
      _rawBubbleCtaSection(resolveReferences: { maxDepth: 100 })
    }
  }
`;
